











import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.12.1 Added click handler.
 * @changelog 6.2.1 Added sort property.
 */
@Component
export default class JdsTableHeading extends Vue {
    @Prop({default: false, type: Boolean}) primary!: boolean;
    @Prop() icon!: string
    @Prop() sort!: 'asc'|'desc'

    get classes() {
        return [
            "jdsc-heading",
            ... (this.primary ? ['jdsc-heading-primary'] : []),
            ... (this.$listeners.click ? ['jds-cursor-pointer'] : [])
        ]
    }

    get sortingIcon() {
        if (this.sort === 'asc') {
            return 'triangle-up';
        }
        return 'triangle-down';
    }

    get ariaSort() {
        if (this.sort === 'asc') {
            return 'ascending';
        } else if (this.sort === 'desc') {
            return 'descending'
        }
        return null;
    }

    onClick(event: UIEvent) {
        if (this.sort) {
            this.$emit('click', this.sort);
        }
    }
}
